import * as React from 'react';
import './style.scss';
import { TravellerCategory } from '../../../models/traveller-category.enum';
import { TranslationService } from '../../../services/translation.service';
import RadioFormGroup from '../RadioFormGroup';
import ValidationInfo from '../../../validation/validation-info';

function TravellerCategorySelector({
  id,
  renderAsDropdown = false,
  selectedTravellerCategory,
  onChange,
}: {
  id: string;
  renderAsDropdown: boolean;
  selectedTravellerCategory: TravellerCategory;
  onChange: (category: TravellerCategory) => void;
}) {
  function handleCategoryChange(value: TravellerCategory) {
    onChange(value);
  }

  return (
    <div className="traveller-category-selector">
      {renderAsDropdown ? (
        <div>
          <label htmlFor={`traveller-category-${id}`} className="form-label">
            {TranslationService.get('common.travellercategory')}
          </label>
          <select
            value={selectedTravellerCategory}
            className="w-100 ms-0 me-0 form-select"
            onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
              handleCategoryChange(e.target.value as TravellerCategory);
            }}
            id={`traveller-category-${id}`}
            name={`traveller-category-${id}`}
          >
            <option value={TravellerCategory.adult}>{TranslationService.get('common.adult')}</option>
            <option value={TravellerCategory.youth}>{TranslationService.get('common.youth')}</option>
          </select>
        </div>
      ) : (
        <RadioFormGroup
          id={`traveller-category-${id}`}
          labelText={TranslationService.get('common.travellercategory')}
          options={[
            { value: TravellerCategory.adult, text: TranslationService.get('common.adult') },
            { value: TravellerCategory.youth, text: TranslationService.get('common.youth') },
          ]}
          rowLayout={true}
          rowLayoutSmUp={true}
          state={{ value: selectedTravellerCategory, validationInfo: new ValidationInfo() }}
          onChange={(value: string) => onChange(value as TravellerCategory)}
        />
      )}
    </div>
  );
}

export default TravellerCategorySelector;
